import * as React from 'react'
import styled, { AnyStyledComponent } from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { agentService, utilService } from '../../../../core/services'
import { BREAKPOINT_TABLET_SMALL } from '../../../../static/constants'
import * as constants from '../../../../static/constants'
import * as interfaces from '../../../../static/interfaces'
import { InputText, InputTextArea, Button, Panel } from '../../../atoms'
import { Form } from '../../../molecules'
import SidebarLayout from '../../_layouts/sidebarLayout'
import ReactSelect from 'react-select'
import SvgIcon from 'components/atoms/SvgIcon'
import { useAgentPostSelection } from 'utils/soundoutOrFormalRequest'

declare var window: interfaces.IWindow

const FIELDS = {
  title: 'title',
  message: 'message',
}

const title = I18n.t('agent.edit', {
  model: I18n.t('tour_memo_template', { scope: 'activerecord.models' }),
})

interface IProps {
  template: IJsonResponse
  posts: IJsonResponse
  user: any
}

const AgentTourMemoTemplateEdit: React.FC<IProps> = props => {
  const { data: template } = agentService.getDataFromJson(props.template)
  const { data: posts } = agentService.getDataFromJson(props.posts)
  const { data: userData } = utilService.getDataFromJson(props.user)

  const { postOptions, selectedPosts, setSelectedPosts } = useAgentPostSelection({
    posts,
    templatePosts: template.posts,
  })

  const handleSubmit = async (_initialValues, values) => {
    const post_ids = selectedPosts.map(post => Number(post.value))
    if (post_ids.length === 0) {
      window.flashMessages.addMessage({
        text: 'postが選択されていないか、postの選択に不備があります。',
        type: 'error',
      })
      return
    }
    const { flush } = await agentService.updateTourMemoTemplate(template.id, {
      ...values,
      post_ids,
    })
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    location.href = '/agent/tour_memo_templates'
  }

  return (
    <SidebarLayout user={userData}>
      <Wrapper>
        <Panel title={title}>
          <Form fields={FIELDS} handleSubmit={handleSubmit}>
            <S.FormItemWrapper>
              <InputText
                required={true}
                name="title"
                defaultValue={template.title || ''}
                label={I18n.t('generic.name')}
              />
            </S.FormItemWrapper>
            <S.FormItemWrapper>
              <InputTextArea
                required={true}
                name="message"
                defaultValue={template.message || ''}
                label={I18n.t('generic.text')}
              />
            </S.FormItemWrapper>
            <S.FormItemWrapper>
              <S.ReactSelectWrapper>
                <p className="ReactSelect_Title">
                  {I18n.t('generic.tour')}
                  <span className="InputText_Required">{I18n.t('generic.required')}</span>
                </p>
                <div className="ReactSelect_Main">
                  <ReactSelect
                    name="post_ids"
                    placeholder={I18n.t('generic.select_tour')}
                    options={postOptions}
                    isMulti={true}
                    onChange={setSelectedPosts}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    value={selectedPosts}
                    menuPortalTarget={typeof window !== 'undefined' ? document.body : undefined}
                  />
                </div>
              </S.ReactSelectWrapper>
            </S.FormItemWrapper>
            <div className="Buttons">
              <Button>
                <a href="/agent/tour_memo_templates">
                  <SvgIcon
                    name="keyboard_arrow_left"
                    className="icon"
                    ariaHidden={true}
                    role="presentation"
                  />
                  {I18n.t('generic.back_to_index')}
                </a>
              </Button>
              <Button primary={true}>{I18n.t('generic.update')}</Button>
            </div>
          </Form>
        </Panel>
      </Wrapper>
    </SidebarLayout>
  )
}

const S: { [key: string]: AnyStyledComponent } = {}

S.FormItemWrapper = styled.div`
  margin-top: 24px;
  .note {
    margin-left: 240px;
    font-size: 14px;
    margin-top: 5px;
    @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
      margin-left: 0px;
    }
  }
`
S.ReactSelectWrapper = styled.div`
  display: flex;
  margin-top: 24px;
  @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
    flex-direction: column;
  }
  .ReactSelect_Title {
    min-width: 240px;
    font-size: 15px;
    font-weight: bold;
    line-height: 1;
    margin-top: 8px;

    .InputText_Required {
      display: inline-block;
      border-radius: 3px;
      color: ${constants.COLORS.white};
      background-color: ${constants.COLORS.caution};
      vertical-align: middle;
      font-size: 11px;
      font-weight: normal;
      padding: 4px 6px;
      margin-left: 8px;
    }

    @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
      width: 100%;
      margin-bottom: 12px;
    }
  }
  .ReactSelect_Main {
    flex: 1;
    font-size: 15px;
  }
`

const Wrapper = styled.div`
  width: 100%;
  padding: 22px 40px 80px 46px;

  .Buttons {
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: 48px;
    @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
      justify-content: flex-end;
    }

    .Button[type='submit'] {
      width: 160px;
    }

    .Button[type='button'] {
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      align-items: center;

      .icon {
        margin-left: -10px;
      }
    }
  }

  .Panel {
    max-width: none;
  }
`

export default AgentTourMemoTemplateEdit
